import { useTranslation } from '@mint-lib/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
} from '@mint-lib/tw-components';

type AssignChannelDialogProps = {
  channelName: string;
  platformName: string;
  onBulkConfirm: () => void;
  onBulkReject: () => void;
  onClose: () => void;
};

export const AssignChannelDialog = ({
  onClose,
  onBulkConfirm,
  onBulkReject,
  channelName,
  platformName,
}: AssignChannelDialogProps) => {
  const { t } = useTranslation('@myn/import-hub');

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={handleOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogRoot size="s">
          <DialogHeader onClose={onClose} className="h-auto">
            <DialogTitle>
              {t(
                'Assign {{channelName}} channel to all platform rows of {{platformName}} platform?',
                { channelName, platformName },
              )}
            </DialogTitle>
          </DialogHeader>
          <DialogContent>
            <DialogDescription>
              {t(
                'By proceeding, you will assign the specified channel to all rows where this platform is present. You can still customize each row individually.',
              )}
            </DialogDescription>
          </DialogContent>
          <DialogFooter>
            <Button
              data-dd-action-name="Assign channel: only this row"
              variant="outlined"
              onClick={onBulkReject}
            >
              {t('No, assign channel only here')}
            </Button>
            <Button
              data-dd-action-name="Assign channel: apply to all"
              color="warning"
              onClick={onBulkConfirm}
            >
              {t('Yes, proceed')}
            </Button>
          </DialogFooter>
        </DialogRoot>
      </DialogPortal>
    </Dialog>
  );
};
